<eg-card-select
  *transloco="let translate"
  [disabled]="disabled"
  [items]="dropdownItems$ | async"
  [itemTemplate]="itemTemplate"
  [tileTemplate]="tileTemplate"
  [hideAllItemsOnEmptyQuery]="false"
  [searchPlaceholder]="translate('forms.search')"
  [keyboardNavigation]="false"
  (dropdownClosed)="markInputAsTouched()"
  (searchValueChange)="onSearchValueChanged($event)"
  (valueSelection)="onSelect($any($event))"
  [value]="value"
  [clearable]="clearable"
>
</eg-card-select>

<ng-template #tileTemplate>
  <div fxFlex="100" fxLayoutAlign="start center" class="label">
    @if (selectedName) {
      <span [class.label-top]="selectedName">{{ labelWithSuffix }}</span>
    }
    <span class="selected-value">{{ selectedName || labelWithSuffix }}</span>
  </div>
</ng-template>

<ng-template #itemTemplate let-item="item" let-selectCallback="selectCallback">
  @if (item.type === 'header') {
    <div fxFlex="100" class="px-8 select__section-title card-select__item-group">{{ item.label }}</div>
  }

  @if (item.type === 'customer') {
    <div fxFlex="100" fxLayoutAlign="start center" class="px-16 select__item" (click)="selectCallback(item)">
      @if (item.customer.lastName) {
        <span class="truncate">{{ item.customer.firstName }} {{ item.customer.lastName }}</span>
      }
      <span class="truncate">&nbsp;({{ item.customer.companyName }}, {{ item.customer.companyId }})</span>
    </div>
  }

  @if (item.type === 'debtor') {
    <div fxFlex="100" fxLayoutAlign="start center" class="px-16 select__item" (click)="selectCallback(item)">
      {{ item.debtor.debtorId }} - {{ item.debtor.name1 }}
      {{ item.debtor?.city ? ' - ' + item.debtor.city : '' }}
    </div>
  }
</ng-template>

@if (control?.touched && control?.errors && errorMessage) {
  <eg-form-error [errorMessage]="displayErrorMessage" class="input-error"></eg-form-error>
}
